import { PosReference } from "@/common/models/PosReference";
import { StoreWorkstationType } from "@/common/models/StoreWorkstationType";

export class StoreWorkstation {
  qrCode: string;
  storeId: number;
  posReference: PosReference;
  type: StoreWorkstationType;

  constructor(qrCode: string, storeId: number, posReference: PosReference, type: StoreWorkstationType) {
    this.qrCode = qrCode;
    this.storeId = storeId;
    this.posReference = posReference;
    this.type = type;
  }
}

export class StoreWorkstationInput {
  qrCode: string;
  storeId: string;
  type: StoreWorkstationType;
  posId: string | null;
  workstationId: number | null;

  constructor(
    qrCode: string,
    storeId: string,
    type: StoreWorkstationType,
    posId: string | null,
    workstationId: number | null
  ) {
    this.qrCode = qrCode;
    this.storeId = storeId;
    this.type = type;
    this.posId = posId;
    this.workstationId = workstationId;
  }
}
